import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { AuthGuard } from './auth/auth-guard.service';
import { NotFoundRedirectComponent } from './helper/not-found-redirect.component';


export const routes: Routes = [
  // {
  //   path: 'client',
  //   loadChildren: () => import('./client/client.module')
  //   .then(m => m.ClientModule)

  // },
  // {
  //   path: 'underwriting',
  //   loadChildren: () => import('./underwriting/underwriting.module')
  //     .then(m => m.UnderwritingModule)
  // },
  {
    path: 'client',
    loadChildren: () => import('./user/user.module')
      .then(m => m.UserModule)

  },

  {
    path: 'manage',
    loadChildren: () => import('./manage/manage.module')
      .then(m => m.ManageModule), canLoad: [AuthGuard]
  },
  {
    path: 'manageb',
    loadChildren: () => import('./manageb/manageb.module').then(m => m.ManagebModule),
    canLoad: [AuthGuard]
  },
  // {
  //   path: 'dates',
  //   component: ShowDatesComponent
  // },
  // {
  //   path: 'dev',
  //   loadChildren: () => import('./dev/dev.module')
  //     .then(m => m.DevModule), 
  // },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
    // loadChildren: './auth/auth.module#AuthModule',
  },

  // {
  // path: 'auth',
  // component: NbAuthComponent,
  // children: [
  //   {
  //     path: '',
  //     component: NbLoginComponent,
  //   },
  //   {
  //     path: 'login',
  //     component: NbLoginComponent,
  //   },    
  //   {
  //     path: 'register',
  //     component: NbRegisterComponent,
  //   },
  //   {
  //     path: 'logout',
  //     component: NbLogoutComponent,
  //   },
  //   {
  //     path: 'request-password',
  //     component: NbRequestPasswordComponent,
  //   },
  //   {
  //     path: 'reset-password',
  //     component: NbResetPasswordComponent,
  //   },
  // ],
  // },
  { path: '', redirectTo: 'auth/login', pathMatch: 'full' },
  { path: '**', component: NotFoundRedirectComponent },
  // tslint:disable-next-line:max-line-length
  // { path: 'calculations', loadChildren: () => import('./calculations/calculations.module').then(m => m.CalculationsModule) },
];

const config: ExtraOptions = {
  useHash: false,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
